import { render, staticRenderFns } from "./SCardHistoryClientComp.vue?vue&type=template&id=b15a58c4&"
import script from "./SCardHistoryClientComp.vue?vue&type=script&lang=js&"
export * from "./SCardHistoryClientComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports